import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import store from '@/store/store';
import Storages from '../utils/storages';

//错误状态码处理提示
class MessageTip extends Vue {
    static messageTipInstance = null;
    messageTip = null;

    constructor() {
        super();
    }
    static instance() {
        if (!this.messageTipInstance) {
        this.messageTipInstance = new MessageTip()
        }
        this.messageTipInstance;
    }

    //提示信息
    msgInfo(msg) {
        this.messageTip && this.messageTip.close();
        this.messageTip = this.$message({
            showClose: true,
            message: msg,
            type: 'error',
            center: true
        });
    }
    //错误信息
    errorInfo(errorCode,data) {
        this.messageTip && this.messageTip.close();
        switch (errorCode) {
            case 400:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '请求错误',
                    type: 'error',
                    center: true
                });
                break;
            case 401:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '未授权',
                    type: 'error',
                    center: true
                });
                break;
            case 403:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '拒绝访问',
                    type: 'error',
                    center: true
                });

                break;
            case 404:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '请求地址出错',
                    type: 'error',
                    center: true
                });
                break;
            case 408:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '请求超时',
                    type: 'error',
                    center: true
                });
                break;
            case 500:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '服务器内部错误',
                    type: 'error',
                    center: true
                });
                break;

            case 501:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '服务器未实现',
                    type: 'error',
                    center: true
                });
                break;

            case 502:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '网络错误',
                    type: 'error',
                    center: true
                });
                break;

            case 503:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '服务不可用',
                    type: 'error',
                    center: true
                });
                break;

            case 504:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || '网关超时',
                    type: 'error',
                    center: true
                });
                break;

            case 505:
                this.messageTip = this.$message({
                    showClose: true,
                    message: data.msg || 'HTTP版本不受支持',
                    type: 'error',
                    center: true
                });
                break;
        }
    }
}

const messageTip = new MessageTip();

let setToken = () => {
    return Storages.getLocalStorage('CHECKTOKEN');
};

axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.withCredentials = true;
// axios.defaults.timeout = 50000;
// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        store.commit('updateLoadingStatus', true);
        //登陆验证
        config.headers.token = setToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        store.commit('updateLoadingStatus', false);
        if(response.data.code!=200){
            messageTip.errorInfo(response.data.code,response.data||{})
            console.log(response.data.msg,55555)
            if (['token失效','token不存在','token 验证失败','用户没有登录或者session已经失效'].includes(response.data.msg)) {
                console.log('退出')
                localStorage.removeItem('ms_username');
                localStorage.removeItem('SSOTOKEN')
                localStorage.removeItem('CHECKTOKEN')
                window.location.reload(); //刷新当前页面
                this.$router.push('/login');
             }
        }
        return response.data;
    },
    error => {
        error &&
            error.response &&
            error.response.data &&
            messageTip.errorInfo(error.response.data.code,error.response.data||{});
            if (['token失效','token不存在','token 验证失败','用户没有登录或者session已经失效'].includes(error.response.data.msg)) {
                        console.log('退出')
                        localStorage.removeItem('ms_username');
                        localStorage.removeItem('SSOTOKEN')
                        localStorage.removeItem('CHECKTOKEN')
                        window.location.reload(); //刷新当前页面
                        this.$router.push('/login');
            }
        return Promise.reject(error.response.data);
    }
);

export default axios

